module.exports = __webpack_public_path__ + "static/media/sonyproduct3banner.6dc29237.jpg";